import React from 'react'
import {
  Div,
} from 'konsys-ui'
import Transfer from '../../../../../components/common/transfer'
import {
  Label, DivTitle,
} from './styled'

const PaperBackCoating = ({
  data = [],
  onChange,
}) => (
    <Div>
      <DivTitle>
        <Label>{'ตัวเลือกการเคลือบผิวกระดาษด้านหลัง'}</Label>
      </DivTitle>
      <Transfer dataSource={data} onChange={onChange}/>
    </Div>
)


export default PaperBackCoating
